import { resolveConfig } from "./config";
import { createPublicApi } from "./public-api";
import { loadWidgetModule } from "./widget-module";
const VERSION = "1.0.0";
export const install = () => {
    if (typeof window === "undefined")
        return;
    const existing = window.SmmAuth;
    if ((existing === null || existing === void 0 ? void 0 : existing.__smmAuthVersion) === VERSION)
        return;
    const api = createPublicApi();
    Object.defineProperty(api, "__smmAuthVersion", {
        value: VERSION,
        enumerable: false,
    });
    window.SmmAuth = api;
    if (resolveConfig().useRequestIdleCallback)
        preloadWhenIdle();
};
export const preloadWhenIdle = () => {
    const run = () => {
        loadWidgetModule()
            .then(({ ensureWidgetLoaded }) => ensureWidgetLoaded())
            .catch((error) => {
            console.warn("[SmmAuth] preload failed", error);
        });
    };
    const idle = window.requestIdleCallback;
    if (idle) {
        idle(run, { timeout: 1500 });
    }
    else {
        window.setTimeout(run, 300);
    }
};
//# sourceMappingURL=lifecycle.js.map